/**
 * @generated SignedSource<<543a1d4ef0d8e2b07e2e7a834b12ce10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardCardActions_project$data = {
  readonly id: string;
  readonly " $fragmentType": "BoardCardActions_project";
};
export type BoardCardActions_project$key = {
  readonly " $data"?: BoardCardActions_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardCardActions_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardCardActions_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "03f197464c6921a577ef09b6e378f127";

export default node;
